// Helpers for building JSON-LD structured data (used with the JsonLd component).
import getVideoId from 'get-video-id'

export const SITE_URL = 'https://www.stanwinstonschool.com'

// Canonical YouTube embed URL for VideoObject.embedUrl, or undefined when the
// URL is missing or not a YouTube video (e.g. a signed S3 mp4, which Google
// can't fetch). Accepts watch?v=, youtu.be/ and already-embed URLs.
export const youtubeEmbedUrl = (url) => {
  if (!url) return undefined
  const { id, service } = getVideoId(url)
  if (service !== 'youtube' || !id) return undefined
  return `https://www.youtube.com/embed/${id}`
}

// Build a BreadcrumbList from an ordered list of { name, path } crumbs, where
// path is site-root-relative (e.g. '/blog'). The last crumb is the current page.
export const breadcrumbList = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`
  }))
})

// The school as a schema.org Organization — reused as author/publisher/provider.
export const ORGANIZATION = {
  '@type': 'Organization',
  name: 'Stan Winston School of Character Arts',
  url: SITE_URL
}

// Build an ISO-8601 duration (e.g. PT3H42M) from hour/minute parts, or
// undefined when there is no duration to report.
export const isoDuration = (hours, minutes) => {
  const h = parseInt(hours, 10) || 0
  const m = parseInt(minutes, 10) || 0
  if (!h && !m) return undefined
  return `PT${h ? `${h}H` : ''}${m ? `${m}M` : ''}`
}
